<template>
  <div class="RoomJoin">
    <div v-if="!room">
      <form>
        <input type="text" v-model="roomName" placeholder="Room name" />
        <button type="submit" @click.prevent="enter" :disabled="!roomName" class="bg screenLarge">Join room</button>
      </form>
    </div>
    <div v-else class="current">
      <button type="submit" @click.prevent="exit" class="red">Leave room: {{room.data.name}}</button>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'RoomJoin',
  components: {
    //Component
  },
  data: function () {
    return {
      roomName: ""
    }
  },
  props: {
  },
  computed: {
    ...mapState('socket',[
      'room'
    ]),
  },
  methods: {
    enter: function () {
      this.$router.push({ name: 'Room', params: { id: this.roomName } })
    },
    exit: function () {
      this.$router.push({ name: 'Home'})
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.RoomJoin{
  text-align: center;
}

.current{
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
